import { Component, Input, OnInit, Output, EventEmitter, HostListener } from '@angular/core';
import { ASSETS_CONSTANTS } from 'src/app/core/constants/Assets-constants';
import { FLAGS_NAME } from 'src/app/core/constants/General-constants';
import { Payment, Transaction } from 'src/app/models';
import { PayvalidaFeatureFlagService } from 'src/app/services/payvalida-feature-flag.service';
import { TokenServiceService } from 'src/app/services/token-service.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-yape-peru',
    templateUrl: './yape-peru.component.html',
    styleUrls: ['./yape-peru.component.scss'],
})
export class YapePeruComponent implements OnInit {
    @Input() info: Payment;
    @Output() YAPE = new EventEmitter();

    transaction: Transaction;
    loading: boolean;
    template: string;
    yape_logo: string = environment.logo_yape;
    yape_video_payvalida_yt: string = 'https://r.payvalida.com/yape-onboarding';
    yape_app_url: string = 'https://r.payvalida.com/checkout/yape-deeplink';
    isMobile: boolean = false;
    yapeAppQr: string = ASSETS_CONSTANTS.YAPE_APP_QR;
    yapeNewQrStepsFF: boolean = false;

    constructor(private readonly tokenServiceService: TokenServiceService, private featureFlagService: PayvalidaFeatureFlagService) { }

    ngOnInit(): void {
        this.setDeviceType(window.innerWidth);
        this.template = this.info.template;
        this.loading = false;
        this.transaction = this.tokenServiceService.getAndDecodeToken();

        this.featureFlagService.getFeatureFlagValue(FLAGS_NAME.YAPE_NEW_QR_STEPS_FF, FLAGS_NAME.YAPE_NEW_QR_STEPS_FF).subscribe((response: boolean) => {
          this.yapeNewQrStepsFF = response;
        });
    }

    changeMethod() {
        this.YAPE.emit();
    }


  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    const width = (event.target as Window).innerWidth;
    this.setDeviceType(width);
  }

  setDeviceType(width: number) {
    this.isMobile = width < 768;
  }
}
